/* eslint-disable default-case */
import { JSEncrypt } from "jsencrypt";
import moment from "moment/moment";
import { Client } from "@stomp/stompjs";
import { casinoPL } from "../pages/game/profitLoss";
import store from "../redux/store";
import { IS_MOCK, createMockSocket } from "./mockData";
import { getGmidByGameKey, getDiamondCodeByGameKey } from "./gameCatalog";
import { transformLiveTableMessage } from "./liveTableTransformer";
import { getCasinoOddsByGame } from "../service/liveTable";

export const PROD_IP = process.env.REACT_APP_API_URL;
export const DEV_IP = process.env.REACT_APP_API_URL;
export const ASSETS_URL = "https://dataobj.ecoassetsservice.com/casino-icons/lc/";
export const GRANDEXCH_URL =
  process.env.REACT_APP_GRANDEXCH_URL || "http://localhost:5050";
export const DIAMOND_CASINO_URL =
  process.env.REACT_APP_DIAMOND_CASINO_URL || "https://apis.professorji.in";
export const LIVE_TABLE_URL =
  process.env.REACT_APP_LIVE_TABLE_URL || "http://localhost:9010/api";
export const AUTH_API_URL =
  process.env.REACT_APP_AUTH_API_URL || "http://localhost:9001/api";
// export const ASSETS_URL = "https://casinoassets.aceodds.in/static/";
// export const ASSETS_URL = "http://assets.hukambet.com/static/"; //local
const CARD_BASE = "/img/cards/";

/**
 * Converts a card code to its local image path.
 * Supports formats:
 *   - Suit-prefixed: "SA" (Spade Ace), "H2" (Heart 2), "DK" (Diamond King), "H10"
 *   - Plain values: "A", "J", "Q", "K"
 *   - Numbers: 2, 3, 10 or "2", "3", "10"
 * Returns card-back image (0.jpg) for unrecognized codes.
 */
export const getCardUrl = (cardCode) => {
  if (!cardCode && cardCode !== 0) return CARD_BASE + "0.jpg";

  const code = String(cardCode);
  const valueMap = { A: 1, J: 11, Q: 12, K: 13 };

  // "1" from provider means face-down / not dealt — show card back
  if (code === "1") return CARD_BASE + "0.jpg";

  // Plain number like "2", "10"
  if (/^\d+$/.test(code)) return CARD_BASE + code + ".jpg";

  // Single face card letter
  if (valueMap[code]) return CARD_BASE + valueMap[code] + ".jpg";

  // Suit-prefixed: first char is suit (S/H/D/C), rest is value
  if (/^[SHDC]/.test(code)) {
    const value = code.substring(1);
    const num = valueMap[value] || parseInt(value) || 0;
    return CARD_BASE + num + ".jpg";
  }

  return CARD_BASE + "0.jpg";
};
export const IS_PROD = (PROD_IP || "").startsWith("casinoapi");
const FileSaver = require("file-saver");
const XLSX = require("xlsx");
const jsPDF = require("jspdf");
var BASE_URL_;
var CRICKET_SERVICE_URL_;
var SOCCER_AND_TENNIS_SERVICE_URL_;
var CASINO_SERVICE_URL_;

BASE_URL_ = !IS_PROD
  ? `http://${process.env.REACT_APP_API_URL}/s1`
  : `https://${process.env.REACT_APP_API_URL}/s1`;
CASINO_SERVICE_URL_ = !IS_PROD
  ? `http://${process.env.REACT_APP_API_URL}`
  : `https://${process.env.REACT_APP_API_URL}`;

export const BASE_URL = BASE_URL_;
export const CRICKET_SERVICE_URL = CRICKET_SERVICE_URL_;
export const SOCCER_AND_TENNIS_SERVICE_URL = SOCCER_AND_TENNIS_SERVICE_URL_;
export const CASINO_SERVICE_URL = CASINO_SERVICE_URL_;
export const PUBLIC_KEY = `-----BEGIN PUBLIC KEY-----
MIIBITANBgkqhkiG9w0BAQEFAAOCAQ4AMIIBCQKCAQB0ZacT13Ok+3pX0lmuJ9dJ
F6atV7Vwv5gmgpvXiBVYKKM4sfGb2qg395uVcampRgLrM63KxElPkWaa90j10ol6
fnHneE3sGuNIrvUmSvtqgeSD8nS4GXdkDecD+HSB7OCOcr+oxsGZzXJdzN/5QyUd
DGpRTlm8T+yB6wa9sJPPgZJ/C650JF57WF+G3qSngqJZEtGrKLlZYL24AqVEg85d
gLsrawWpZUEGeYqhYsdSeoGqkAR6E8Ybw+YWEYCFyMLZi2Fe5MVwMARWQ5kzpKTx
0ur7DPsghrAem08DIAekAN97F1DS48Vs88T29C2716ylE27ICyiMLDw9DLXekhAD
AgMBAAE=
-----END PUBLIC KEY-----`;
export const buttonColors = "#D4AF37";
export const blueColor = "#007bff";
export const bgColor = "#eee";
export const secondaryColor = "#e2e8f0";
export const casinoBgColor = "#ffffff";
export const applyFancyFor = [
  "Over By Over",
  "Normal",
  "Ball By Ball",
  "meter",
  // "fancy1",
  // "oddeven",
];
export const sortByStringNumberInEnd = (a, b) => {
  const aNumber = parseInt(a);
  const bNumber = parseInt(b);
  if (aNumber && bNumber) {
    return aNumber - bNumber;
  } else if (aNumber) {
    return -1;
  } else if (bNumber) {
    return 1;
  } else {
    return a.localeCompare(b);
  }
};
var ENCRYPT = new JSEncrypt();
ENCRYPT.setPublicKey(PUBLIC_KEY);
export const Encrypt = (data) => ENCRYPT.encrypt(data);
export const getToken = () => {
  return store.getState().account.userData.token;
};
export const getCurrentDateTimeLocal = (
  prev = false,
  date_ = false,
  time = false
) => {
  let date = new Date(); // create a new Date object with the current date and time
  let year = date.getFullYear(); // get the four-digit year (e.g. 2023)
  let month = ("0" + (date.getMonth() + 1)).slice(-2); // get the month as a zero-padded two-digit string (e.g. "03")
  let day = ("0" + date.getDate()).slice(-2); // get the day of the month as a zero-padded two-digit string (e.g. "04")
  /*  let hour = ("0" + date.getHours()).slice(-2); // get the hour as a zero-padded two-digit string (e.g. "09")
  let minute = ("0" + date.getMinutes()).slice(-2); // get the minute as a zero-padded two-digit string (e.g. "05") */
  if (prev) {
    if (date_) {
      day = ("0" + (date.getDate() - date_)).slice(-2);
    } else {
      day = ("0" + (date.getDate() - 1)).slice(-2);
    }
  }
  let formattedDate = `${day}-${month}-${year}`; // concatenate the year, month, and day with hyphens as the separator
  return formattedDate;
};

export const convertEpochToDate = (epoch) => {
  return moment(epoch + "Z").format("DD/MM/YYYY hh:mm A");
};
export function searchSubstringInArrayObjects(array, keys, searchString) {
  return array.filter((obj) => {
    return keys.some((key) => {
      if (!obj[key]) return false;
      return String(obj[key])
        .toLowerCase()
        .includes(searchString.toLowerCase());
    });
  });
}
export const getProfit = (selectedAmount, game, selectedEventForBet) => {
  let profit;
  let loss;
  let selectedAmount_ = selectedEventForBet.amount;
  if (game == "casino") {
    profit = casinoPL(
      selectedEventForBet.selectedOdd,
      selectedAmount_,
      selectedEventForBet.type
    ).profit;
    loss = casinoPL(
      selectedEventForBet.selectedOdd,
      selectedAmount_,
      selectedEventForBet.type
    ).loss;
  }
  return {
    profit: parseFloat(profit).toFixed(2),
    loss: parseFloat(loss).toFixed(2),
  };
};

// Game key -> Redux action type mapping
const GAME_ACTION_MAP = {
  dragonTiger20: "gameData/setDragonTiger20Odds",
  casinoMeter: "gameData/setCasinoMeterOdds",
  teenPatti20: "gameData/setTeenPatti20Odds",
  dragonTiger202: "gameData/setDragonTiger202Odds",
  lucky7: "gameData/setLucky7Odds",
  lucky7eu: "gameData/setLucky7euOdds",
  casinoQueen: "gameData/setCasinoQueenOdds",
  aaa: "gameData/setAaaOdds",
  poker20: "gameData/setPoker20Odds",
  dragonTigerOneDay: "gameData/setDragonTigerOneDayOdds",
  teen: "gameData/setTeenOdds",
  andarBahar20: "gameData/setAndarBahar20Odds",
  abj: "gameData/setAbjOdds",
  card32: "gameData/setCard32Odds",
  dragonTigerLion: "gameData/setDragonTigerLionOdds",
  teen8: "gameData/setTeen8Odds",
  teen9: "gameData/setTeen9Odds",
  poker9: "gameData/setPoker9Odds",
  poker1Day: "gameData/setPoker1DayOdds",
  card32eu: "gameData/setCard32euOdds",
  baccarat2: "gameData/setBaccarat20Odds",
  race20: "gameData/setRace20Odds",
  worli2: "gameData/setWorli2Odds",
  bollywoodTable: "gameData/setBollywoodTableOdds",
  casinoWar: "gameData/setCasinoWarOdds",
  baccarat: "gameData/setBaccaratOdds",
  cmatch20: "gameData/setCmatch20Odds",
  worli: "gameData/setWorliOdds",
  superOver: "gameData/setSuperOverOdds",
  cricketV3: "gameData/setCricketv3Odds",
};

// --- STOMP WebSocket for live odds ---

// Module-level state — tracked to prevent leaks on game switch
let activeStompClient = null;
let countdownInterval = null;
let loadingTimeout = null;

export const disconnectOdds = () => {
  if (countdownInterval) {
    clearInterval(countdownInterval);
    countdownInterval = null;
  }
  if (loadingTimeout) {
    clearTimeout(loadingTimeout);
    loadingTimeout = null;
  }
  if (activeStompClient) {
    activeStompClient.deactivate();
    activeStompClient = null;
  }
};

/**
 * Build the STOMP broker URL.
 * Backend WebSocket endpoint is at /api/websocket (not /live-table/websocket).
 * https://host -> wss://host/api/websocket
 * http://host  -> ws://host/api/websocket
 */
export const buildBrokerURL = () => {
  const loc = window.location;
  const protocol = loc.protocol === "https:" ? "wss:" : "ws:";
  return `${protocol}//${loc.host}/api/websocket`;
};

export const connectOdds = (dispatch, gameKey = "dragonTiger20") => {
  // Disconnect previous connection before starting new one
  disconnectOdds();

  const diamondCode = getDiamondCodeByGameKey(gameKey);
  const gmid = getGmidByGameKey(gameKey);
  const actionType = GAME_ACTION_MAP[gameKey];

  if (!diamondCode || !gmid || !actionType) return;

  dispatch({ type: "accountData/setLoading", payload: true });

  // Safety timeout: clear loading state if no data arrives within 15s.
  // Prevents infinite loading spinner for inactive/unavailable games.
  if (loadingTimeout) clearTimeout(loadingTimeout);
  loadingTimeout = setTimeout(() => {
    if (!hasReceivedData) {
      dispatch({ type: "accountData/setLoading", payload: false });
    }
    loadingTimeout = null;
  }, 15000);

  let hasReceivedData = false;
  let lastPayload = null;
  let lastServerAutoTime = null;
  let countdownRemaining = null;

  /**
   * Start a client-side countdown that decrements autoTime every second.
   * The server pushes messages only on data changes (not every second),
   * so we tick locally to keep the timer smooth.
   *
   * Only restarts when the server's autoTime actually changes — prevents
   * mid-countdown resets (e.g. timer jumping from 8 back to 20) caused by
   * odds-only updates that carry the same ft value.
   *
   * Countdown ticks read the latest lastPayload at tick time so odds data
   * is never stale.
   */
  const startCountdown = (serverAutoTime) => {
    // Skip if the server sent the same autoTime we're already counting from
    if (serverAutoTime === lastServerAutoTime && countdownInterval) return;
    lastServerAutoTime = serverAutoTime;

    if (countdownInterval) {
      clearInterval(countdownInterval);
      countdownInterval = null;
    }

    if (!serverAutoTime || serverAutoTime <= 0) {
      countdownRemaining = null;
      return;
    }

    countdownRemaining = serverAutoTime;

    countdownInterval = setInterval(() => {
      countdownRemaining -= 1;
      if (countdownRemaining <= 0) {
        countdownRemaining = 0;
        clearInterval(countdownInterval);
        countdownInterval = null;
      }
      // Read lastPayload at tick time so we always have the freshest odds
      if (lastPayload) {
        dispatch({
          type: actionType,
          payload: { ...lastPayload, autoTime: countdownRemaining },
        });
      }
    }, 1000);
  };

  /**
   * Process odds data from either REST or WebSocket, dispatch to Redux.
   */
  const processOddsData = (oddsData) => {
    if (!oddsData) return;

    let payload;
    if (oddsData.oddDetailsDTOS) {
      payload = {
        marketId: oddsData.marketId || "",
        autoTime: oddsData.autoTime != null ? oddsData.autoTime : undefined,
        cards: oddsData.cards || [],
        oddDetailsDTOS: oddsData.oddDetailsDTOS || [],
        fancyOddDetailsDTOS: oddsData.fancyOddDetailsDTOS || [],
        fancy2OddDetailsDTOS: oddsData.fancy2OddDetailsDTOS || [],
        gtype: oddsData.gtype || "",
        remark: oddsData.remark || "",
        _raw: oddsData,
      };
    } else {
      payload = transformLiveTableMessage(oddsData, gmid);
    }

    // For partial updates (odds-only messages that omit timer or some markets),
    // preserve previous values so we don't reset fields that weren't in the message.
    if (payload && lastPayload) {
      // Preserve timer when message doesn't include ft/autoTime (odds-only update).
      // Without this, missing ft defaults to 0 which kills the running countdown.
      if (payload.autoTime == null) {
        payload.autoTime = lastPayload.autoTime || 0;
      }
      if (payload.oddDetailsDTOS === undefined) {
        payload.oddDetailsDTOS = lastPayload.oddDetailsDTOS || [];
      }
      if (payload.fancyOddDetailsDTOS === undefined) {
        payload.fancyOddDetailsDTOS = lastPayload.fancyOddDetailsDTOS || [];
      }
      if (payload.fancy2OddDetailsDTOS === undefined) {
        payload.fancy2OddDetailsDTOS = lastPayload.fancy2OddDetailsDTOS || [];
      }
      // Preserve cards when message doesn't include card field (odds-only update).
      // Without this, missing card defaults to [] which wipes the displayed cards.
      if (!payload.cards || payload.cards.length === 0) {
        payload.cards = lastPayload.cards || [];
      }
    }

    // Compute isSuspended from runner status (gstatus from provider).
    // When gstatus is not OPEN/ACTIVE, the provider has suspended betting.
    // Also flag as suspended when ALL runners have zero odds AND none are
    // explicitly marked ACTIVE — covers the brief gap between rounds where
    // timer resets but odds haven't arrived yet.
    const runners = payload.oddDetailsDTOS || [];
    if (runners.length > 0) {
      const allZeroOdds = runners.every(
        (r) => !r.back1 || r.back1 === "0" || r.back1 === 0
      );
      const hasActiveRunner = runners.some(
        (r) => r.status === "ACTIVE" || r.status === "OPEN"
      );
      // Suspended only if ALL odds are zero AND no runner is marked active
      payload.isSuspended = allZeroOdds && !hasActiveRunner;
    } else {
      payload.isSuspended = true;
    }

    lastPayload = payload;

    // When the countdown is already running and the server sent the same
    // autoTime (odds-only update, not a new round), use the local countdown
    // value instead of the server's value. This prevents the timer from
    // briefly jumping (e.g. 8 → 20 → 7) on odds-only WebSocket updates.
    const isOddsOnlyUpdate =
      payload.autoTime === lastServerAutoTime &&
      countdownInterval &&
      countdownRemaining != null;
    const dispatchPayload = isOddsOnlyUpdate
      ? { ...payload, autoTime: countdownRemaining }
      : payload;
    dispatch({ type: actionType, payload: dispatchPayload });

    if (!hasReceivedData) {
      hasReceivedData = true;
      dispatch({ type: "accountData/setLoading", payload: false });
    }

    // Only restart countdown when autoTime actually changes from the server.
    // This prevents timer jumping (e.g. 8 → 20) on odds-only updates.
    startCountdown(payload.autoTime);
  };

  // One-time REST fetch for instant initial data while WebSocket connects.
  // Skip countdown from REST — its `ft` value may be stale (full round time
  // rather than current remaining). WebSocket will set the authoritative timer.
  getCasinoOddsByGame(diamondCode)
    .then((response) => {
      const responseData = response?.data;
      let oddsData = responseData?.data?.data;

      if (oddsData && oddsData.statusCode !== undefined && oddsData.data) {
        oddsData = oddsData.data?.data || oddsData.data;
      }

      // Process odds data but don't start countdown — set autoTime to 0
      // so the timer waits for the first real-time WebSocket message
      if (oddsData) {
        oddsData = { ...oddsData, ft: 0, autoTime: 0 };
      }
      processOddsData(oddsData);
    })
    .catch(() => {
      // Initial fetch failed — WebSocket will provide data once connected
    });

  // STOMP WebSocket connection
  const client = new Client({
    brokerURL: buildBrokerURL(),
    reconnectDelay: 3000,
    onConnect: () => {
      client.subscribe(`/odds/${diamondCode}`, (message) => {
        try {
          const parsed = JSON.parse(message.body);

          // Server sends nested envelope:
          // { data: { statusCode, message, data: { data: { mid, sub, ft, ... } } } }
          let oddsData = parsed;
          if (oddsData?.data?.data?.data) {
            oddsData = oddsData.data.data.data;
          } else if (oddsData?.data?.data) {
            oddsData = oddsData.data.data;
          } else if (oddsData?.data) {
            oddsData = oddsData.data;
          }

          processOddsData(oddsData);
        } catch {
          // Malformed message — skip
        }
      });
    },
    onStompError: () => {
      // STOMP protocol error — reconnect handled automatically
    },
  });

  client.activate();
  activeStompClient = client;
};
export const updateReduxToken = (token) => (dispatch) => {
  dispatch({
    type: "accountData/setToken",
    payload: token,
  });
};

export const exportToCsvReactCsv = (csvData, fileName) => {
  const fileType =
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
  const fileExtension = ".xlsx";
  const data = csvData;
  const ws = XLSX.utils.json_to_sheet(data);
  const wb = { Sheets: { data: ws }, SheetNames: ["data"] };
  const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
  const data1 = new Blob([excelBuffer], { type: fileType });
  FileSaver.saveAs(data1, fileName + fileExtension);
};

export const exportToPdf = (component) => {
  const doc = new jsPDF.jsPDF();
  doc.html(document.querySelector("#" + component), {
    callback: function (pdf) {
      pdf.save(component + ".pdf");
    },
  });
};

export const pokerGameList = [
  {
    name: "super over",
    url: "superover.jpg",
    path: "superOver",
  },
  {
    name: "race 20-20",
    url: "race20.png",
    path: "race20",
  },
  {
    name: "casino queen",
    url: "queen.jpg",
    path: "casinoQueen",
  },
  {
    name: "5five cricket",
    url: "5five cricket.jpg",
    path: "cricketV3",
  },
  {
    name: "andar-bahar2",
    url: "andar-bahar2.jpg",
    path: "abj",
  },
  {
    name: "20-20 dragon tiger 2",
    url: "20-20 dragon tiger 2.jpg",
    path: "dragonTiger202",
  },
  {
    name: "baccarat2",
    url: "baccarat2.jpg",
    path: "baccarat2",
  },
  {
    name: "baccarat",
    url: "baccarat.png",
    path: "baccarat",
  },
  {
    name: "lucky7-b",
    url: "lucky7-b.jpg",
    path: "lucky7eu",
  },
  {
    name: "casino queen",
    url: "queen.jpg",
    path: "casinoQueen",
  },
  {
    name: "20-20 cricket match",
    url: "20-20 cricket match.jpg",
    path: "cmatch20",
  },
  {
    name: "casino meter",
    url: "casino meter.jpg",
    path: "",
  },
  {
    name: "casino war",
    url: "casino war.jpg",
    path: "casinoWar",
  },
  {
    name: "20-20 dtl",
    url: "20-20 dtl.jpg",
    path: "dragonTigerLion",
  },
  {
    name: "20-20 teenpatti",
    url: "test teenpatti.jpg",
    path: "teenPatti20",
  },
  {
    name: "test teenpatti",
    url: "test teenpatti.jpg",
    path: "teen9",
  },
  {
    name: "open teenpatti",
    url: "open teenpatti.jpg",
    path: "teen8",
  },
  {
    name: "1 day teenpatti",
    url: "1 day teenpatti.jpg",
    path: "teen",
  },
  {
    name: "6 player poker",
    url: "6 player poker.jpg",
    path: "poker9",
  },
  // {
  //   name: "1 day poker",
  //   url: "1 day poker.jpg",
  //   path: "poker",
  // },
  {
    name: "20-20 poker",
    url: "20-20 poker.jpg",
    path: "poker20",
  },
  {
    name: "andar-bahar",
    url: "andar-bahar.jpg",
    path: "andarBahar20",
  },
  // {
  //   name: "worli matka",
  //   url: "worli matka.jpg",
  //   path: "worli",
  // },
  {
    name: "instant worli",
    url: "instant worli.jpg",
    path: "worli2",
  },
  // {
  //   name: "3 cards Judgement",
  //   url: "3 cards Judgement.jpg",
  //   path: "3cardsjudgement",
  // },
  {
    name: "32cardsA",
    url: "32cardsA.jpg",
    path: "card32",
  },
  {
    name: "32cardsB",
    url: "32cardsB.jpg",
    path: "card32eu",
  },
  {
    name: "amar akbar anthony",
    url: "amar akbar anthony.jpg",
    path: "aaa",
  },
  {
    name: "bollywood-casino",
    url: "bollywood-casino.jpg",
    path: "bollywoodTable",
  },
  {
    name: "20-20 dragon tiger",
    url: "20-20 dragon tiger.jpg",
    path: "dragonTiger20",
  },
  {
    name: "1 day dragon tiger",
    url: "1 day dragon tiger.jpg",
    path: "dragonTigerOneDay",
  },
  {
    name: "lottery",
    url: "lottery.jpg",
    path: "",
  },
  {
    name: "lucky7-a",
    url: "lucky7-a.jpg",
    path: "lucky7",
  },
];
export const sidebarCasinoList = [
  {
    name: "race 20-20",
    url: "race20.png",
    path: "race20",
  },
  {
    name: "casino queen",
    url: "queen.jpg",
    path: "casinoQueen",
  },

  {
    name: "Dragon Tiger",
    url: "20-20 dragon tiger 2.jpg",
    path: "?name=dragon-tiger",
  },
  {
    name: "Sports Casino",
    url: "",
    path: "?name=sports-casino",
  },
  {
    name: "Andar Bahar",
    url: "",
    path: "?name=andar-bahar",
  },

  {
    name: "Bollywood Casino",
    url: "casino war.jpg",
    path: "?name=bollywood",
  },
  {
    name: "Casino War",
    url: "casino war.jpg",
    path: "casinoWar",
  },

  // {
  //   name: "worli matka",
  //   url: "worli matka.jpg",
  //   path: "worli",
  // },
  {
    name: "Worli",
    url: "instant worli.jpg",
    path: "worli2",
  },
  {
    name: "lottery",
    url: "lottery.jpg",
    path: "",
  },
];
